var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUplinkLogo600(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 108 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h107.473v26.006H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.977 8.763c-2.194 0-4 1.805-4 4 0 .5.1 1 .28 1.46l-.88 2.4a6.026 6.026 0 0 1-1.4-3.86c0-3.292 2.708-6 6-6 3.291 0 6 2.708 6 6 0 1.47-.53 2.81-1.4 3.86l-.88-2.4c.18-.46.28-.96.28-1.46 0-2.195-1.806-4-4-4m0-4c-4.389 0-8 3.611-8 8 0 2.36 1 4.5 2.64 5.94l-.72 2a10.005 10.005 0 0 1-3.92-7.94c0-5.486 4.514-10 10-10s10 4.514 10 10c0 3.23-1.54 6.11-3.92 7.94l-.72-2c1.64-1.44 2.64-3.58 2.64-5.94 0-4.389-3.611-8-8-8Z",
    style: {
      fill: "#4f46e5",
      fillRule: "nonzero"
    },
    transform: "translate(-2.773 -3.875) scale(1.40263)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4c2.194 0 4 1.806 4 4s-1.806 4-4 4-4-1.806-4-4 1.806-4 4-4",
    style: {
      fill: "#4f46e5",
      fillRule: "nonzero"
    },
    transform: "translate(4.976 7.93) scale(.7542)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14c4.42 0 8 1.79 8 4v2H4v-2c0-2.21 3.58-4 8-4Z",
    style: {
      fill: "#4f46e5",
      fillRule: "nonzero"
    },
    transform: "translate(6.426 12.496) scale(.63336)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M.513-.727h.153v.472a.248.248 0 0 1-.143.232.357.357 0 0 1-.158.033.358.358 0 0 1-.159-.033.25.25 0 0 1-.143-.232v-.472h.154v.459a.15.15 0 0 0 .018.074.15.15 0 0 0 .052.051.16.16 0 0 0 .078.018.16.16 0 0 0 .078-.018.139.139 0 0 0 .07-.125v-.459Z",
    style: {
      fillRule: "nonzero"
    },
    transform: "translate(33.198 21.117) scale(23.89968)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.061.205v-.75H.21v.091h.006a.228.228 0 0 1 .029-.045.15.15 0 0 1 .05-.038.171.171 0 0 1 .076-.016c.04 0 .077.011.111.031a.22.22 0 0 1 .08.094c.02.041.03.093.03.156a.356.356 0 0 1-.029.154.206.206 0 0 1-.267.112.172.172 0 0 1-.08-.081H.212v.292H.061Zm.148-.478c0 .033.004.061.013.085a.123.123 0 0 0 .039.056c.017.014.038.02.062.02a.095.095 0 0 0 .063-.02.132.132 0 0 0 .039-.057.265.265 0 0 0 0-.167.123.123 0 0 0-.039-.056.1.1 0 0 0-.063-.02.1.1 0 0 0-.062.019.129.129 0 0 0-.039.056.24.24 0 0 0-.013.084Z",
    style: {
      fillRule: "nonzero"
    },
    transform: "translate(50.92 21.117) scale(23.89968)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero"
    },
    d: "M.061-.727h.151V0H.061z",
    transform: "translate(65.483 21.117) scale(23.89968)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.06 0v-.545h.152V0H.06Zm.077-.616a.08.08 0 0 1-.058-.022.071.071 0 0 1-.024-.054c0-.021.008-.039.024-.054a.081.081 0 0 1 .057-.023c.023 0 .042.008.058.023a.071.071 0 0 1 .024.054.071.071 0 0 1-.024.054.08.08 0 0 1-.057.022Z",
    style: {
      fillRule: "nonzero"
    },
    transform: "translate(71.153 21.117) scale(23.89968)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.212-.315V0H.061v-.545h.144v.096h.006a.152.152 0 0 1 .061-.076.189.189 0 0 1 .103-.028c.038 0 .071.009.099.025a.18.18 0 0 1 .066.071.248.248 0 0 1 .023.11V0H.412v-.32c0-.034-.008-.06-.026-.079a.09.09 0 0 0-.071-.028.108.108 0 0 0-.054.013.101.101 0 0 0-.036.038.128.128 0 0 0-.013.061Z",
    style: {
      fillRule: "nonzero"
    },
    transform: "translate(76.822 21.117) scale(23.89968)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.197-.157.001-.181H.22l.175-.207h.173l-.234.274H.297l-.1.114ZM.061 0v-.727h.151V0H.061Zm.34 0-.16-.237.1-.107L.578 0H.401Z",
    style: {
      fillRule: "nonzero"
    },
    transform: "translate(90.809 21.117) scale(23.89968)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUplinkLogo600);
export default __webpack_public_path__ + "static/media/uplink-logo-600.70984fc95e1c8a0dd166951518a34f91.svg";
export { ForwardRef as ReactComponent };